import React, { useEffect, useRef, useState } from "react";
import { Info } from "lucide-react";

/**
 * Ikona „i" s krátkým vysvětlením. Místo řádku šedého textu pod nadpisem:
 * na počítači se ukáže po najetí, na telefonu po klepnutí (druhé klepnutí
 * nebo klepnutí jinam ji zavře).
 */
export default function Napoveda({ children, className = "", testid }) {
  const [otevreno, setOtevreno] = useState(false);
  const obal = useRef(null);
  useEffect(() => {
    if (!otevreno) return undefined;
    const pryc = (e) => { if (!obal.current?.contains(e.target)) setOtevreno(false); };
    document.addEventListener("pointerdown", pryc);
    return () => document.removeEventListener("pointerdown", pryc);
  }, [otevreno]);
  return (
    <span ref={obal} className={`relative inline-flex ${className}`}
      onMouseEnter={() => setOtevreno(true)} onMouseLeave={() => setOtevreno(false)}>
      <button type="button" aria-label="Vysvětlení" aria-expanded={otevreno} data-testid={testid}
        onClick={(e) => { e.stopPropagation(); setOtevreno((v) => !v); }}
        className="tap md:min-h-0 md:min-w-0 h-6 w-6 inline-flex items-center justify-center rounded-full text-muted-2 hover:text-ink">
        <Info size={14} strokeWidth={2.2} />
      </button>
      {otevreno && (
        <span role="tooltip"
          className="vyber-menu absolute z-50 left-1/2 -translate-x-1/2 top-[calc(100%+6px)] w-[240px] rounded-[10px] bg-ink text-white text-[12px] leading-snug font-500 px-3 py-2 shadow-panel">
          {children}
        </span>
      )}
    </span>
  );
}
